<div class="opacity-control">
  <div class="opacity-control__label">
    {{ renderedViewRegion()?.name }}
  </div>

  <div class="opacity-control__slider">
    <mat-slider>
      <input [formControl]="opacityControl" matSliderThumb>
    </mat-slider>
  </div>
</div>
